import * as React from 'react';
import { themeResolver } from './themeResolver.js';
import { defaultTheme } from './Theme.js';

var ThemeContext = /*#__PURE__*/React.createContext(themeResolver(defaultTheme));
var ThemeProvider = function ThemeProvider(_ref) {
  var theme = _ref.theme,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: themeResolver(theme)
  }, children);
};

export { ThemeContext, ThemeProvider };
